(function () {
  function initPremiumPasswordVideo(video) {
    if (!video) return;

    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
      return;
    }

    video.muted = true;
    video.defaultMuted = true;
    video.playsInline = true;
    video.autoplay = true;
    video.setAttribute('muted', '');
    video.setAttribute('playsinline', '');
    video.setAttribute('webkit-playsinline', '');

    var tryPlay = function () {
      var promise = video.play();
      if (promise && typeof promise.catch === 'function') {
        promise.catch(function () {
          // Ignore autoplay errors; we retry on user/visibility events below.
        });
      }
    };

    // First attempt as soon as possible.
    tryPlay();

    // Retry when the tab/page becomes active again (common on iOS Safari).
    document.addEventListener('visibilitychange', function () {
      if (!document.hidden) tryPlay();
    });
    window.addEventListener('pageshow', tryPlay);

    // Final fallback: any user gesture should resume playback.
    var retryOnGesture = function () {
      tryPlay();
    };
    document.addEventListener('touchstart', retryOnGesture, { once: true });
    document.addEventListener('click', retryOnGesture, { once: true });
  }

  function init() {
    var videos = document.querySelectorAll('.js-password-premium-video');
    videos.forEach(initPremiumPasswordVideo);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
    return;
  }

  init();
})();
